import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
// import * as PIXI from 'pixi.js'
// import { fb, tw } from '../koko-framework/social'
import { setupClicker } from '../controller/ButtonController'

export class SharePop extends koko.view {
    currentGameView = null;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6},

            { type: 'container', name: 'popContainer', x: vp.centerX, y: vp.centerY },
                { type: 'sprite', parent: 'popContainer', id: 'sp_carrier', name: 'sp_carrier', x: 0, y: 0, width: 642, height: 334, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'popContainer', id: 'close_btn', name: 'close_btn', x: 234, y: -98, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5},
                { type: 'bmptext', parent: 'popContainer', text: 'Share this game using the\nbuttons below!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: 0, y: -60, anchorX: 0.5, anchorY: 0},
                { type: 'sprite', parent: 'popContainer', id: 'twitter_btn', name: 'twitter_btn', x: -100, y: 60, width: 160, height: 62, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'popContainer', id: 'fb_btn', name: 'fb_btn', x: 100, y: 60, width: 160, height: 62, anchorX: 0.5, anchorY: 0.5},

            /*
            { type: 'sprite', id: 'wronganswer_carrier', name: 'bg2', x: vp.centerX, y: 400, width: 642, height: 333, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'wronganswer_title', name: 'title', x: vp.centerX, y: 343, width: 98, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'That answer wasn\'t quite right,\nhave another go!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: 408, anchorX: 0.5, anchorY: 0},
            */
        ], this.container);

        this.resize();
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    transitionIn = (currentGameView = null) => {
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.transitionInDone});

        // setTimeout(this.transitionOut, 2000);

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.closePop);
        this.children.fb_btn.interactive = true;
        this.children.fb_btn.on(event, this.fbShare);
        this.children.twitter_btn.interactive = true;
        this.children.twitter_btn.on(event, this.twitterShare);
        */

        au.playRandom('pop', 1, 10);
    }

    transitionInDone = () => {
        setupClicker(this.children.close_btn, this.closePop);
        setupClicker(this.children.fb_btn, this.fbShare);
        setupClicker(this.children.twitter_btn, this.twitterShare);
    }

    transitionOut = () => {
        this.children.close_btn.interactive = false;

        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }

        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    closePop = (e) => {
        au.play('button', 1, false);
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }
        this.transitionOut();
    }

    twitterShare = () => {
        au.play('button', 1, false);
        // tw.share_simple(window.SHARE_MESSAGE, window.SHARE_HASH_TAGE, window.SHARE_URL);
        window.document.getElementById('twitterShareLink').click();
    }

    fbShare = () => {
        au.play('button', 1, false);
        // fb.share_ui(window.SHARE_MESSAGE, window.SHARE_HASH_TAGE, window.SHARE_URL);
        window.document.getElementById('facebookShareLink').click();
    }
}